export default __webpack_public_path__ + "static/media/logo.84a80196.png";